import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createSlots as _createSlots, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '../../assets/img/login-staps/pwd.png'
import _imports_1 from '@/assets/img/yandex-short.png'
import _imports_2 from '../../assets/img/general/tg.svg'
import _imports_3 from '../../assets/img/login-staps/pwd-repeat.png'
import _imports_4 from '../../assets/img/login-staps/pwd-send.png'
import _imports_5 from '../../assets/img/login-staps/call.png'
import _imports_6 from '../../assets/img/login-staps/support.png'
import _imports_7 from '../../assets/img/login-staps/question.png'
import _imports_8 from '../../assets/img/general/max-black.svg'
import _imports_9 from '../../assets/img/general/error.svg'


const _hoisted_1 = {
  class: "login-container bg-background",
  id: "login"
}
const _hoisted_2 = { class: "login-form mt-10" }
const _hoisted_3 = { class: "absolute top-12 left-0 flex w-full select-none items-center justify-between px-[24px]" }
const _hoisted_4 = { class: "form-input" }
const _hoisted_5 = { class: "mt-5" }
const _hoisted_6 = { class: "form-password" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "mt-2 text-center text-sm text-red"
}
const _hoisted_10 = { class: "flex flex-col space-y-2" }
const _hoisted_11 = { class: "mx-4 flex justify-center" }
const _hoisted_12 = { class: "flex flex-col justify-center text-center border border-grey-400 p-4 rounded-lg space-y-2" }
const _hoisted_13 = { class: "form-password" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = ["disabled", "value"]
const _hoisted_16 = { class: "form-input" }
const _hoisted_17 = {
  key: 0,
  class: "mt-2 flex justify-center text-grey"
}
const _hoisted_18 = { class: "flex flex-col space-y-4" }
const _hoisted_19 = {
  key: 0,
  class: "flex flex-col justify-center text-center border border-grey-400 p-4 rounded-lg space-y-2"
}
const _hoisted_20 = { class: "mx-4 mt-4" }
const _hoisted_21 = {
  key: 0,
  src: _imports_5,
  class: "w-[4rem] mx-auto"
}
const _hoisted_22 = {
  key: 1,
  src: _imports_6,
  class: "w-[4rem] mx-auto"
}
const _hoisted_23 = { class: "text-center font-medium text-xl flex flex-col items-center space-y-4" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "animate-pulse" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "text-center text-grey-400 my-4" }
const _hoisted_28 = { class: "text-center mb-4 text-grey" }
const _hoisted_29 = { class: "flex justify-between" }
const _hoisted_30 = { class: "mt-6 flex justify-center" }
const _hoisted_31 = {
  key: 0,
  class: "flex absolute bottom-0 right-0"
}
const _hoisted_32 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputComponent = _resolveComponent("InputComponent")!
  const _component_CheckboxComponent = _resolveComponent("CheckboxComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_LoginStep = _resolveComponent("LoginStep")!
  const _component_button_component = _resolveComponent("button-component")!
  const _component_login_step = _resolveComponent("login-step")!
  const _component_input_component = _resolveComponent("input-component")!
  const _component_TelegramBanner = _resolveComponent("TelegramBanner")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_confirm_modal = _resolveComponent("confirm-modal")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[65] || (_cache[65] = _createElementVNode("div", { class: "flex justify-center" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.currentStep === _ctx.enumLoginSteps.CreatePass)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "flex h-9 items-center justify-center rounded-lg bg-greyLight px-4 text-grey",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changePhone && _ctx.changePhone(...args)))
            }, [...(_cache[34] || (_cache[34] = [
              _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1),
              _createElementVNode("div", { class: "ml-3 text-sm" }, "Назад", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.RepeatPass)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "flex h-9 items-center justify-center rounded-lg bg-greyLight px-4 text-grey",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentStep = _ctx.enumLoginSteps.CreatePass))
            }, [...(_cache[35] || (_cache[35] = [
              _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1),
              _createElementVNode("div", { class: "ml-3 text-sm" }, "Назад", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.ActivationMethod)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "flex h-9 items-center justify-center rounded-lg bg-greyLight px-4 text-grey",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentStep = _ctx.enumLoginSteps.RepeatPass))
            }, [...(_cache[36] || (_cache[36] = [
              _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1),
              _createElementVNode("div", { class: "ml-3 text-sm" }, "Назад", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.TelegramRedirect)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "flex h-9 items-center justify-center rounded-lg bg-greyLight px-4 text-grey",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentStep = _ctx.enumLoginSteps.EnterPhone))
            }, [...(_cache[37] || (_cache[37] = [
              _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1),
              _createElementVNode("div", { class: "ml-3 text-sm" }, "Назад", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.CheckOTP)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: "flex h-9 items-center justify-center rounded-lg bg-greyLight px-4 text-grey",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetData && _ctx.resetData(...args)))
            }, [...(_cache[38] || (_cache[38] = [
              _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1),
              _createElementVNode("div", { class: "ml-3 text-sm" }, "В начало", -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        (_ctx.currentStep === _ctx.enumLoginSteps.EnterPhone)
          ? (_openBlock(), _createBlock(_component_LoginStep, {
              key: 0,
              title: ['Вход в кабинет выплат для', 'водителей и курьеров'],
              subtitle: "Введите ваш номер телефона в поле ниже"
            }, {
              action: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_InputComponent, {
                    modelValue: _ctx.phone,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.phone) = $event)),
                    model: _ctx.phone,
                    onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateFieldInput('phone'))),
                    maxlength: "15",
                    rounded: "md",
                    id: "loginPhone",
                    prefix: "+7",
                    height: "h-14",
                    border: false,
                    onPaste: _ctx.onPaste,
                    disabled: _ctx.hasRequest,
                    background: "bg-greyLight",
                    mask: '(###) ### ## ##',
                    placeholder: "(***) *** ** **",
                    type: "tel"
                  }, null, 8, ["modelValue", "model", "onPaste", "disabled"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_CheckboxComponent, {
                      disabled: _ctx.hasRequest,
                      model: _ctx.termsConditionFirst,
                      onUpdate: _cache[8] || (_cache[8] = (value) => (_ctx.termsConditionFirst = value))
                    }, {
                      label: _withCtx(() => [
                        _cache[39] || (_cache[39] = _createTextVNode(" Я ознакомился и согласен с ", -1)),
                        _createElementVNode("a", {
                          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.openLink(`${_ctx.privacyLink}`)), ["stop"])),
                          href: "#",
                          class: "text-blue underline"
                        }, " политикой конфиденциальности ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "model"]),
                    _createVNode(_component_CheckboxComponent, {
                      disabled: _ctx.hasRequest,
                      model: _ctx.termsConditionSecond,
                      onUpdate: _cache[10] || (_cache[10] = (value) => (_ctx.termsConditionSecond = value)),
                      class: "mt-4"
                    }, {
                      label: _withCtx(() => [
                        _cache[40] || (_cache[40] = _createTextVNode(" Я ознакомился и согласен с ", -1)),
                        _createElementVNode("a", {
                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.openLink(`${_ctx.agreementLink}`)), ["stop"])),
                          href: "#",
                          class: "text-blue underline"
                        }, " пользовательским соглашением ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "model"])
                  ]),
                  _createVNode(_component_ButtonComponent, {
                    type: "submit",
                    title: "Продолжить",
                    font: "normal",
                    rounded: "md",
                    disabled: 
                    _ctx.phone.length !== 15 ||
                    !_ctx.termsConditionSecond ||
                    !_ctx.termsConditionFirst
                  ,
                    class: "mt-5 h-14 font-normal",
                    loading: _ctx.hasRequest,
                    color: 
                    _ctx.phone.length === 15 &&
                    _ctx.termsConditionSecond &&
                    _ctx.termsConditionFirst
                      ? 'primary'
                      : 'greyLight'
                  ,
                    onClickAction: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sendPhoneToValidate()))
                  }, null, 8, ["disabled", "loading", "color"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.CreatePass)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _cache[42] || (_cache[42] = _createElementVNode("img", {
                src: _imports_0,
                class: "w-[4rem] mx-auto"
              }, null, -1)),
              _createVNode(_component_login_step, {
                subtitle: 
              _ctx.isNeedRegistration
                ? 'Комбинацию из 5 цифр \n — этот пароль вы будете использовать для входа в приложение'
                : 'Который вы установили при первом входе'
            ,
                title: 
              _ctx.isNeedRegistration
                ? ['Придумайте новый пароль']
                : ['Введите пароль']
            ,
                attention: 
              _ctx.passwordError && _ctx.passwordError.length ? _ctx.passwordError : null
            
              }, {
                action: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                        return _createElementVNode("input", {
                          key: i,
                          class: _normalizeClass([{ active: _ctx.password[i - 1] }, "input-box focus:border focus:border-yellow-200"]),
                          onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.keyDownEvent('password')), ["delete"])),
                          onInput: _cache[13] || (_cache[13] = ($event: any) => (
                        _ctx.inputPasswordEvent('password', $event.target.value)
                      )),
                          ref_for: true,
                          ref: "input",
                          type: "password",
                          value: _ctx.password[i - 1],
                          onFocus: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onFocusPassword('password'))),
                          inputmode: "numeric",
                          pattern: "[0-9]*",
                          autocomplete: "off",
                          maxlength: "1"
                        }, null, 42, _hoisted_8)
                      }), 64))
                    ]),
                    _createVNode(_component_button_component, {
                      disabled: !_ctx.isCreateContinueEnabled,
                      class: "form-button mb-3",
                      loading: _ctx.hasRequest,
                      id: "continueButton",
                      font: "normal",
                      type: "submit",
                      rounded: "md",
                      color: _ctx.isCreateContinueEnabled ? 'primary' : 'greyLight',
                      onClickAction: _ctx.validateIsNeedRegistration,
                      title: "Продолжить"
                    }, null, 8, ["disabled", "loading", "color", "onClickAction"])
                  ]),
                  (_ctx.isNeedRegistration && _ctx.passwordWeakHint)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.passwordWeakHint), 1))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", null, [...(_cache[41] || (_cache[41] = [
                    _createElementVNode("div", {
                      id: "yandex-auth-container-login",
                      class: "yandex-button mt-2"
                    }, null, -1)
                  ]))], 512), [
                    [_vShow, !_ctx.helpLoginDialog]
                  ])
                ]),
                _: 1
              }, 8, ["subtitle", "title", "attention"])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.TelegramRedirect)
          ? (_openBlock(), _createBlock(_component_login_step, {
              key: 2,
              title: `Вы можете установить пароль к аккаунту ${_ctx.phone}`,
              subtitle: "Удобным для вас способом:\n            "
            }, {
              action: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_button_component, {
                      class: "form-button",
                      font: "normal",
                      rounded: "md",
                      color: "primary",
                      onClickAction: _cache[15] || (_cache[15] = ($event: any) => (_ctx.currentStep = _ctx.enumLoginSteps.CreatePass))
                    }, _createSlots({ _: 2 }, [
                      (_ctx.yandexAppEnabled)
                        ? {
                            name: "title",
                            fn: _withCtx(() => [
                              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "" }, [
                                _createTextVNode(" Установить пароль через "),
                                _createElementVNode("span", { class: "inline-flex items-center gap-1 whitespace-nowrap" }, [
                                  _createElementVNode("strong", null, "ЗВОНОК"),
                                  _createTextVNode(" / "),
                                  _createElementVNode("img", {
                                    src: _imports_1,
                                    class: "w-5 h-5"
                                  }),
                                  _createElementVNode("strong", null, "Яндекс ID")
                                ])
                              ], -1))
                            ]),
                            key: "0"
                          }
                        : {
                            name: "title",
                            fn: _withCtx(() => [
                              _cache[44] || (_cache[44] = _createTextVNode("Установить пароль через ", -1)),
                              _cache[45] || (_cache[45] = _createElementVNode("strong", null, "ЗВОНОК", -1))
                            ]),
                            key: "1"
                          }
                    ]), 1024)
                  ]),
                  _cache[48] || (_cache[48] = _createElementVNode("div", { class: "flex items-center justify-center text-gray-600 text-sm mb-4" }, " ИЛИ ", -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openTelegram())),
                      class: "flex items-center justify-center select-none cursor-pointer overflow-hidden px-6 text-center transition-all duration-300 rounded-md grey h-14 font-normal bg-primary w-full text-grey opacity-100"
                    }, [...(_cache[46] || (_cache[46] = [
                      _createTextVNode(" Перейти в ", -1),
                      _createElementVNode("img", {
                        src: _imports_2,
                        alt: "telegram",
                        class: "ml-2 w-6 h-6"
                      }, null, -1),
                      _createElementVNode("strong", { class: "ml-1" }, "Telegram", -1)
                    ]))]),
                    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "text-gray-600 text-sm" }, " Это обезопасит вас от мошенников и вы сможете получать коды доступа для входа ", -1))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.RepeatPass)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _cache[49] || (_cache[49] = _createElementVNode("img", {
                src: _imports_3,
                class: "w-[4rem] mx-auto"
              }, null, -1)),
              _createVNode(_component_login_step, {
                title: ['Повторите пароль'],
                attention: 
              !_ctx.passwordRepeat.length && _ctx.passwordRepeatError
                ? _ctx.passwordRepeatError
                : null
            
              }, {
                action: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                        return _createElementVNode("input", {
                          key: i,
                          class: _normalizeClass([{ active: _ctx.passwordRepeat[i - 1] }, "input-box focus:border focus:border-yellow-200"]),
                          ref_for: true,
                          ref: "input",
                          onKeyup: _cache[17] || (_cache[17] = _withKeys(($event: any) => (_ctx.keyDownEvent('passwordRepeat')), ["delete"])),
                          onFocus: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onFocusPassword('passwordRepeat'))),
                          disabled: _ctx.hasRequest,
                          onInput: _cache[19] || (_cache[19] = ($event: any) => (
                        _ctx.inputPasswordEvent(
                          'passwordRepeat',
                          $event.target.value,
                        )
                      )),
                          value: _ctx.passwordRepeat[i - 1],
                          inputmode: "numeric",
                          pattern: "[0-9]*",
                          type: "password",
                          autocomplete: "off",
                          maxlength: "1"
                        }, null, 42, _hoisted_15)
                      }), 64))
                    ]),
                    _createVNode(_component_button_component, {
                      disabled: 
                    _ctx.passwordRepeat.length < 5 || _ctx.passwordRepeat !== _ctx.password
                  ,
                      class: "form-button",
                      font: "normal",
                      type: "submit",
                      loading: _ctx.hasRequest,
                      rounded: "md",
                      color: _ctx.passwordRepeat.length === 5 ? 'primary' : 'greyLight',
                      title: "Продолжить",
                      onClickAction: _ctx.activateUser
                    }, null, 8, ["disabled", "loading", "color", "onClickAction"])
                  ])
                ]),
                _: 1
              }, 8, ["attention"])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.CheckOTP)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _cache[52] || (_cache[52] = _createElementVNode("img", {
                src: _imports_4,
                class: "w-[4rem] mx-auto"
              }, null, -1)),
              _createVNode(_component_login_step, {
                attention: _ctx.otpError && _ctx.otpError.length ? _ctx.otpError : null,
                title: 
              _ctx.loginType === 'phone'
                ? ['На ваш телефон поступит звонок', 'Возьмите трубку']
                : ['Вам в Telegram отправлен код для входа', 'Впишите его ниже']
            
              }, _createSlots({
                action: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_input_component, {
                      modelValue: _ctx.otp,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.otp) = $event)),
                      model: _ctx.otp,
                      height: "h-14",
                      rounded: "md",
                      border: false,
                      background: "bg-greyLight",
                      loading: _ctx.hasRequest,
                      onInput: _ctx.validateOTP,
                      onKeyup: _cache[22] || (_cache[22] = ($event: any) => (_ctx.validateFieldInput('otp'))),
                      maxlength: "5",
                      placeholder: 
                    _ctx.loginType == 'phone' ? 'Код из звонка' : 'Код из Telegram'
                  ,
                      outlined: "",
                      type: "tel"
                    }, null, 8, ["modelValue", "model", "loading", "onInput", "placeholder"])
                  ]),
                  (_ctx.callsTries < 2 && _ctx.loginType == 'phone')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.nextCallTime > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Позвонить еще раз (" + _toDisplayString(_ctx.nextCallTime) + "c) ", 1))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "mt-2 flex cursor-pointer justify-center text-blue",
                              onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.sendNewCall && _ctx.sendNewCall(...args)))
                            }, " Позвонить еще раз ")),
                        _createVNode(_component_TelegramBanner, { class: "mt-5" })
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, [
                (_ctx.loginType !== 'phone')
                  ? {
                      name: "title",
                      fn: _withCtx(() => [
                        _createElementVNode("div", null, "На ваш Telegram " + _toDisplayString(_ctx.phone) + " отправлен код для входа", 1),
                        _createElementVNode("div", null, [
                          _cache[50] || (_cache[50] = _createTextVNode(" Перейдите по ", -1)),
                          _createElementVNode("span", {
                            class: "text-blue cursor-pointer",
                            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onTelegramCodeLinkClick && _ctx.onTelegramCodeLinkClick(...args)))
                          }, "ссылке")
                        ]),
                        _cache[51] || (_cache[51] = _createElementVNode("div", null, "Впишите его ниже", -1))
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["attention", "title"])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.ActivationMethod)
          ? (_openBlock(), _createBlock(_component_LoginStep, {
              key: 5,
              title: "Подтвердите активацию",
              subtitle: _ctx.yandexAppEnabled ? 'Выберите способ подтверждения' : ''
            }, {
              action: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  (_ctx.yandexAppEnabled)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[53] || (_cache[53] = [
                        _createElementVNode("div", { class: "text-gray-600 text-sm" }, " Один клик — и вы в системе. ", -1),
                        _createElementVNode("div", {
                          id: "yandex-auth-container-activation",
                          class: "yandex-button"
                        }, null, -1)
                      ]))], 512)), [
                        [_vShow, !_ctx.helpLoginDialog]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_ButtonComponent, {
                    class: "form-button mb-3",
                    font: "normal",
                    rounded: "md",
                    color: "primary",
                    onClickAction: _ctx.sendActivationCall,
                    title: "Через ЗВОНОК"
                  }, null, 8, ["onClickAction"])
                ])
              ]),
              _: 1
            }, 8, ["subtitle"]))
          : _createCommentVNode("", true),
        (_ctx.currentStep === _ctx.enumLoginSteps.Confirmation)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              (_ctx.activeTab === 'call')
                ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                : (_openBlock(), _createElementBlock("img", _hoisted_22)),
              _createVNode(_component_LoginStep, {
                title: 
              _ctx.activeTab === 'call'
                ? `Позвоните с номера ${this.phone}`
                : 'Проблема со ЗВОНКОМ'
            ,
                subtitle: 
              _ctx.activeTab === 'call'
                ? `на номер ниже в течение 5 минут \n Убедитесь что совершаете звонок с номера ${this.phone}, иногда вызов может идти со второй сим карты!`
                : `Код подтверждения аккаунта ${this.phone}`
            
              }, _createSlots({ _: 2 }, [
                (_ctx.activeTab === 'call')
                  ? {
                      name: "action",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneNumberCallConfirmed, (number, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex space-x-4 items-center ml-6"
                            }, [
                              _createElementVNode("a", {
                                class: "cursor-pointer select-none border rounded-full py-2 px-6 text-center text-blue-500 hover:shadow-blue-200 flex items-center justify-center gap-2 mx-auto max-w-[280px] bg-[#0FC22F] text-white",
                                href: `tel:${number}`
                              }, [
                                _cache[54] || (_cache[54] = _createElementVNode("i", { class: "fas fa-phone text-sm rotate-90 animate-pulse" }, null, -1)),
                                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.formatCallConfirmNumber(number)), 1)
                              ], 8, _hoisted_24),
                              _createElementVNode("div", {
                                class: "cursor-pointer",
                                onClick: ($event: any) => (_ctx.copyNumber(number))
                              }, [...(_cache[55] || (_cache[55] = [
                                _createElementVNode("i", { class: "fa fa-copy text-sm text-[1rem] text-[#787878]" }, null, -1)
                              ]))], 8, _hoisted_26)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_27, " Ожидание звонка " + _toDisplayString(_ctx.formatTime(_ctx.remainingTime)), 1),
                        (!_ctx.isCallConfirmed && _ctx.remainingTime <= 240)
                          ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                              key: 0,
                              title: 
                    _ctx.isManualCallCheckDisabled ? 'Проверяем...' : 'Я позвонил'
                  ,
                              color: "primary",
                              rounded: "md",
                              class: "w-full h-14 mb-6",
                              onClickAction: _ctx.manuallyCheckStatus,
                              disabled: _ctx.isManualCallCheckDisabled
                            }, null, 8, ["title", "onClickAction", "disabled"]))
                          : _createCommentVNode("", true)
                      ]),
                      key: "0"
                    }
                  : {
                      name: "action",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_28, [
                          _cache[56] || (_cache[56] = _createTextVNode(" Подготовьте скриншот данного экрана и предоставьте его в поддержку", -1)),
                          _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1)),
                          _cache[58] || (_cache[58] = _createTextVNode(" ( ", -1)),
                          (_ctx.showMaxSupport)
                            ? (_openBlock(), _createElementBlock("strong", {
                                key: 0,
                                class: "cursor-pointer text-blue underline",
                                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleMAXSupportRequest && _ctx.handleMAXSupportRequest(...args)))
                              }, "MAX "))
                            : _createCommentVNode("", true),
                          _cache[59] || (_cache[59] = _createTextVNode("/", -1)),
                          _createElementVNode("strong", {
                            class: "cursor-pointer text-blue underline",
                            onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.handleTelegramSupportRequest && _ctx.handleTelegramSupportRequest(...args)))
                          }, "Telegram "),
                          _cache[60] || (_cache[60] = _createTextVNode(") ", -1))
                        ]),
                        _createVNode(_component_InputComponent, {
                          modelValue: _ctx.manualCode,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.manualCode) = $event)),
                          model: _ctx.manualCode,
                          maxlength: "5",
                          placeholder: "00000",
                          height: "h-14",
                          rounded: "md",
                          border: false,
                          background: "bg-greyLight",
                          type: "tel",
                          class: "mb-4",
                          onInput: _ctx.validateManualCode
                        }, null, 8, ["modelValue", "model", "onInput"]),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_ButtonComponent, {
                            title: "Назад",
                            color: "greyLight",
                            rounded: "md",
                            class: "h-14 flex-1 mr-2",
                            onClickAction: _cache[27] || (_cache[27] = ($event: any) => (_ctx.backBtn()))
                          }),
                          _createVNode(_component_ButtonComponent, {
                            title: 'Подтвердить',
                            disabled: _ctx.manualCode.length !== 5,
                            color: _ctx.manualCode.length === 5 ? 'primary' : 'greyLight',
                            rounded: "md",
                            class: "h-14 flex-1 ml-2",
                            loading: _ctx.isSubmittingCode,
                            onClickAction: _ctx.submitManualCode
                          }, null, 8, ["disabled", "color", "loading", "onClickAction"])
                        ])
                      ]),
                      key: "1"
                    }
              ]), 1032, ["title", "subtitle"]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  type: "button",
                  class: "text-red font-medium border border-red rounded-md px-4 py-2",
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showCloseConfirm = true))
                }, " В начало "),
                (
                _ctx.currentStep === _ctx.enumLoginSteps.Confirmation &&
                _ctx.activeTab === 'call'
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-blue font-medium underline",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.switchTab('code')))
                      }, [...(_cache[61] || (_cache[61] = [
                        _createElementVNode("img", {
                          class: "w-[1.5rem] opacity-30",
                          src: _imports_7
                        }, null, -1)
                      ]))])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.showCloseConfirm)
                ? (_openBlock(), _createBlock(_component_ConfirmModal, {
                    key: 2,
                    state: _ctx.showCloseConfirm,
                    description: "Вы уверены, что хотите закрыть окно подтверждения? Все данные будут сброшены.",
                    "confirm-button-text": "Да, закрыть",
                    "decline-button-text": "Отмена",
                    onConfirm: _ctx.handleCloseConfirmation,
                    onDecline: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showCloseConfirm = false))
                  }, null, 8, ["state", "onConfirm"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])), [
        [_directive_auto_animate]
      ]),
      (_ctx.showMaxSupport)
        ? (_openBlock(), _createBlock(_component_confirm_modal, {
            key: 0,
            description: 
          _ctx.currentStep === _ctx.enumLoginSteps.Confirmation
            ? `Перед обращением в поддержку проверьте что звонок совершался с номера ${this.phone}. \n(иногда звонок идет со второй сим карты) \n Остались вопросы? Решим!\n Подготовьте скриншот экрана!`
            : 'У Вас трудность? Решим! Подготовьте скриншот экрана!'
        ,
            state: _ctx.helpLoginDialog,
            "decline-button-text": "Не сейчас",
            onConfirm: _ctx.handleMAXSupportRequest,
            onConfirmSecondary: _ctx.handleTelegramSupportRequest,
            onDecline: _cache[31] || (_cache[31] = ($event: any) => (_ctx.helpLoginDialog = false))
          }, {
            "confirm-title": _withCtx(() => [...(_cache[62] || (_cache[62] = [
              _createElementVNode("div", { class: "flex items-center font-medium" }, [
                _createElementVNode("div", null, "В MAX"),
                _createElementVNode("div", { class: "ml-2 text-2xl" }, [
                  _createElementVNode("img", {
                    src: _imports_8,
                    alt: "MAX",
                    class: "w-4 h-4 items-center text-center align-middle"
                  })
                ])
              ], -1)
            ]))]),
            "confirm-secondary-title": _withCtx(() => [...(_cache[63] || (_cache[63] = [
              _createElementVNode("div", { class: "flex items-center font-medium" }, [
                _createElementVNode("div", null, "В Telegram"),
                _createElementVNode("div", { class: "ml-2 text-2xl" }, [
                  _createElementVNode("i", { class: "fab fa-telegram-plane" })
                ])
              ], -1)
            ]))]),
            _: 1
          }, 8, ["description", "state", "onConfirm", "onConfirmSecondary"]))
        : (_openBlock(), _createBlock(_component_confirm_modal, {
            key: 1,
            description: 
          _ctx.currentStep === _ctx.enumLoginSteps.Confirmation
            ? `Перед обращением в поддержку проверьте что звонок совершался с номера ${this.phone}. \n(иногда звонок идет со второй сим карты) \n Остались вопросы? Решим!\n Подготовьте скриншот экрана!`
            : 'У Вас трудность? Решим! Подготовьте скриншот экрана!'
        ,
            state: _ctx.helpLoginDialog,
            "decline-button-text": "Не сейчас",
            onConfirm: _ctx.handleTelegramSupportRequest,
            onDecline: _cache[32] || (_cache[32] = ($event: any) => (_ctx.helpLoginDialog = false))
          }, {
            "confirm-title": _withCtx(() => [...(_cache[64] || (_cache[64] = [
              _createElementVNode("div", { class: "flex items-center font-medium" }, [
                _createElementVNode("div", null, "В Telegram"),
                _createElementVNode("div", { class: "ml-2 text-2xl" }, [
                  _createElementVNode("i", { class: "fab fa-telegram-plane" })
                ])
              ], -1)
            ]))]),
            _: 1
          }, 8, ["description", "state", "onConfirm"]))
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'absolute maxH:static bottom-12 min-top-[600px] flex flex-col items-center rounded-full px-4 py-1 text-sm font-medium',
          _ctx.isHelpButtonEnabled
            ? 'bg-primary text-grey cursor-pointer'
            : 'bg-greyLight text-greyDisabled cursor-not-allowed opacity-50',
        ]),
        onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.handleHelpButtonClick && _ctx.handleHelpButtonClick(...args)))
      }, [...(_cache[66] || (_cache[66] = [
        _createElementVNode("div", { class: "flex items-center" }, [
          _createElementVNode("div", { class: "text-2xl" }, [
            _createElementVNode("img", {
              src: _imports_9,
              alt: "MAX",
              class: "w-5 h-5 items-center text-center align-middle"
            })
          ]),
          _createElementVNode("div", { class: "ml-2 text-base" }, "Не могу войти")
        ], -1)
      ]))], 2)
    ])
  ]))
}